import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import {connect} from 'react-redux';
import InventoryList from 'Lots/Components/Inventory/inventory-list';
import ItemList from 'Lots/Components/Inventory/item-list';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import * as LotActionType from '../constants';

export class HomeInventory extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      lot: PropTypes.object,
      location: PropTypes.any,
      history: PropTypes.any
    }

    constructor(props) {
      super(props);
      this.state = {
        lot: null
      };
    }
    onTabChange = (tab) => {
      const { location, history } = this.props;
      const queryParams = queryString.parse(location.search);

      history.push({
        pathname: location.pathname,
        search: queryString.stringify({
          ...queryParams,
          subTab: tab,
          categoryId: null
        })
      });
    }

    onGetCategoryItemList = (params) => {
      const { builderProfile } = this.props.lot.extensionValue;

      this.props.dispatch({
        type: LotActionType.GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_ASYNC,
        params: {
          data: {
            lotId: params.lotId,
            group: params.group,
            groupOrderType: params.groupOrderType,
            search: params.search,
            filter: {
              categories: params.categoryIds || []
            }
          },
          builderHost: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        }
      });
    }

    render() {
      const { location } = this.props;
      const queryParams = queryString.parse(location.search);
      return (
        <React.Fragment>
          <Tab.Container
            id='left-tabs-example'
            defaultActiveKey='categories'
            className='s1-stack-tab'
            activeKey={queryParams.subTab}
            onSelect={this.onTabChange}
          >
            <Row className='clearfix'>
              <Col sm={2} style={{ paddingRight: 0 }}>
                <Nav bsStyle='pills' stacked>
                  <NavItem eventKey='categories'>Inventory</NavItem>
                  <NavItem eventKey='category-items'>Inventory Items</NavItem>
                </Nav>
              </Col>
              <Col sm={10}>
                <Tab.Content
                  unmountOnExit animation
                  style={{paddingLeft: 15, paddingRight: 15, border: '1px solid #e6e6e6', backgroundColor: '#fff' }}>
                  <Tab.Pane eventKey='categories' mountOnEnter={true} unmountOnExit={true} >
                    <InventoryList lot={this.props.lot} />
                  </Tab.Pane>
                  <Tab.Pane eventKey='category-items' mountOnEnter={true} unmountOnExit={true} >
                    <ItemList lot={this.props.lot} onGetCategoryItemList={this.onGetCategoryItemList} />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    categoryItemList1: state.LotStore.categoryItemList,
    categoryList1: state.LotStore.categoryList
  };
};

export default withRouter(connect(mapStateToProps)(HomeInventory));



// WEBPACK FOOTER //
// ./src/Lots/Containers/home-hub-home-inventory.js